import React, { useState } from 'react';

import HeroSection from './HeroSection/HeroSection';

const terms = [
  {
    id: 1,
    number: 'I.- ',
    title: 'TNC.FIRST.TITLE',
    descriptions: [
      { label: 'TNC.FIRST.DESCRIPTION.LABEL_ONE' },
      { label: 'TNC.FIRST.DESCRIPTION.LABEL_TWO' },
    ],
    active: false,
  },

  {
    id: 2,
    number: 'II.- ',
    title: 'TNC.SECOND.TITLE',
    descriptions: [
      { label: 'TNC.SECOND.DESCRIPTION.LABEL_ONE' },
      { label: 'TNC.SECOND.DESCRIPTION.LABEL_TWO' },
      { label: 'TNC.SECOND.DESCRIPTION.LABEL_THREE' },
      { label: 'TNC.SECOND.DESCRIPTION.LABEL_FOUR' },
    ],
    active: false,
    otherPoints: {
      title: 'TNC.SECOND.OTHER_POINTS.TITLE',
      points: [
        { label: 'TNC.SECOND.OTHER_POINTS.POINT_ONE' },
        { label: 'TNC.SECOND.OTHER_POINTS.POINT_TWO' },
        { label: 'TNC.SECOND.OTHER_POINTS.POINT_THREE' },
        { label: 'TNC.SECOND.OTHER_POINTS.POINT_FOUR' },
        { label: 'TNC.SECOND.OTHER_POINTS.POINT_FIVE' },
        { label: 'TNC.SECOND.OTHER_POINTS.POINT_SIX' },
        { label: 'TNC.SECOND.OTHER_POINTS.POINT_SEVEN' },
        { label: 'TNC.SECOND.OTHER_POINTS.POINT_EIGHT' },
        { label: 'TNC.SECOND.OTHER_POINTS.POINT_NINE' },
      ],
    },
  },
  {
    id: 3,
    number: 'III.- ',
    title: 'TNC.THIRD.TITLE',
    descriptions: [{ label: 'TNC.THIRD.DESCRIPTION.LABEL_ONE' }],
    active: false,
  },

  {
    id: 4,
    number: 'IV.- ',
    title: 'TNC.FOUR.TITLE',
    descriptions: [
      { label: 'TNC.FOUR.DESCRIPTION.LABEL_ONE' },
      { label: 'TNC.FOUR.DESCRIPTION.LABEL_TWO' },
      { label: 'TNC.FOUR.DESCRIPTION.LABEL_THREE' },
      { label: 'TNC.FOUR.DESCRIPTION.LABEL_FOUR' },
      { label: 'TNC.FOUR.DESCRIPTION.LABEL_FIVE' },
      { label: 'TNC.FOUR.DESCRIPTION.LABEL_SIX' },
    ],
    active: false,
  },

  {
    id: 5,
    number: 'V.- ',
    title: 'TNC.FIVE.TITLE',
    descriptions: [{ label: 'TNC.FIVE.DESCRIPTION.LABEL_ONE' }],
    active: false,
    otherPoints: {
      // title: 'TNC.FIVE.OTHER_POINTS.TITLE',
      points: [
        { label: 'TNC.FIVE.OTHER_POINTS.POINT_ONE' },
        { label: 'TNC.FIVE.OTHER_POINTS.POINT_TWO' },
        { label: 'TNC.FIVE.OTHER_POINTS.POINT_THREE' },
        { label: 'TNC.FIVE.OTHER_POINTS.POINT_FOUR' },
        { label: 'TNC.FIVE.OTHER_POINTS.POINT_FIVE' },
        { label: 'TNC.FIVE.OTHER_POINTS.POINT_SIX' },
      ],
    },
  },

  {
    id: 6,
    number: 'VI.- ',
    title: 'TNC.SIX.TITLE',
    // descriptions: [
    //     { label: 'TNC.SIX.DESCRIPTION.LABEL_ONE' },
    // ],
    active: false,
    otherPoints: {
      // title: 'TNC.SIX.OTHER_POINTS.TITLE',
      points: [
        { label: 'TNC.SIX.OTHER_POINTS.POINT_ONE' },
        { label: 'TNC.SIX.OTHER_POINTS.POINT_TWO' },
        { label: 'TNC.SIX.OTHER_POINTS.POINT_THREE' },
        { label: 'TNC.SIX.OTHER_POINTS.POINT_FOUR' },
        { label: 'TNC.SIX.OTHER_POINTS.POINT_SIX' },
        { label: 'TNC.SIX.OTHER_POINTS.POINT_SEVEN' },
        { label: 'TNC.SIX.OTHER_POINTS.POINT_EIGHT' },
        { label: 'TNC.SIX.OTHER_POINTS.POINT_NINE' },
      ],
    },
  },

  {
    id: 7,
    number: 'VII.- ',
    title: 'TNC.SEVEN.TITLE',
    descriptions: [{ label: 'TNC.SEVEN.DESCRIPTION.LABEL_ONE' }],
    active: false,
    otherPoints: {
      title: 'TNC.SEVEN.OTHER_POINTS.TITLE',
      points: [
        { label: 'TNC.SEVEN.OTHER_POINTS.POINT_ONE' },
        { label: 'TNC.SEVEN.OTHER_POINTS.POINT_TWO' },
        { label: 'TNC.SEVEN.OTHER_POINTS.POINT_THREE' },
      ],
    },
  },

  {
    id: 8,
    number: 'VIII.- ',
    title: 'TNC.EIGHT.TITLE',
    descriptions: [{ label: 'TNC.EIGHT.DESCRIPTION.LABEL_ONE' }],
    active: false,
  },
  {
    id: 9,
    number: 'IX.- ',
    title: 'TNC.NINE.TITLE',
    descriptions: [
      { label: 'TNC.NINE.DESCRIPTION.LABEL_ONE' },
      { label: 'TNC.NINE.DESCRIPTION.LABEL_TWO' },
    ],
    active: false,
  },
];

const Termsandconditions = ({ t }) => {
  const [list, setList] = useState(terms);

  const handleToggle = item => {
    const data = JSON.parse(JSON.stringify(list));

    const updatedList = data.map(v => {
      if (v.id === item.id) {
        v.active = v.active ? false : true;
        return v;
      } else {
        v.active = false;
        return v;
      }
    });

    setList(updatedList);
  };
  return (
    <div className="pages-terms-and-conditions" style={{ marginBottom: '50vh' }}>
      <HeroSection
        title="Términos y condiciones"
        description="Home  /  Términos y condiciones"
        height="40vh"
        heroImage="/images/tnc/PullmanBus-TermsConditions-Banner.jpg"
      />

      {/* <div className="content-container">
        <div className="heading-title">
          Conoce nuestros términos de uso
          <span className="yellow-line"></span>
        </div>
      </div> */}
      <div className="content-container">
        <div className="pullman-section-primary-row">
          <div className="pullman-section-primary-row-main-heading black-text margin-T30">
            {t('TNC.HEADING')}
            {/* Terms and conditions */}
          </div>
          <div className="pullman-section-primary-row-underline margin-B35"></div>
        </div>

        {list.map((val, i) => {
          return (
            <div className="single-item" key={i}>
              <div
                className={`header ${val.active ? 'hide-bg' : 'show-bg'}`}
                onClick={() => handleToggle(val)}
              >
                <span className="point-number">{val.number}</span>
                <span className="title black-text">{t(val.title)}</span>
                <img
                  className="arrow"
                  src={`/images/tnc/PullmanBus-TermsConditions-Arrow-${
                    val.active ? 'Up' : 'Down'
                  }.svg`}
                  alt=""
                />
              </div>

              {/* Selected Item */}
              {val.active ? (
                <div className="selected-item">
                  {/* Description  */}
                  {val.descriptions && val.descriptions.length > 0
                    ? val.descriptions.map((d, i) => {
                        return (
                          <div className="description" key={i}>
                            <span>{t(d.label)}</span>
                            <br />
                            <br />
                          </div>
                        );
                      })
                    : null}

                  {/* Other Points */}
                  {val.otherPoints ? (
                    <div className="other-points">
                      {val.otherPoints.title ? (
                        <div className="title">{t(val.otherPoints.title)}</div>
                      ) : null}
                      {val.otherPoints.points && val.otherPoints.points.length > 0
                        ? val.otherPoints.points.map((p, i) => {
                            return (
                              <div className="points-section">
                                <span className="number">{i + 1}. </span>
                                <span className="label">{t(p.label)}</span>
                              </div>
                            );
                          })
                        : null}
                    </div>
                  ) : null}
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Termsandconditions;

// import React, { Component } from 'react';

// export default class TermsAndConditions extends Component {
//   static propTypes = {};

//   componentDidMount() {
//     window.scrollTo(0, 0);
//   }

//   render() {
//     return (
//       <div className="content-container cancel-done-section pages-terms-and-conditions font10">
//         <div className="cancel-ticket-done font20 page-title">
//           Términos<span className="bold-text">&nbsp;y condiciones</span>
//         </div>

//         <div className=" contact-us-item tnc-item">
//           <div className="my-1">
//             <span className="image-inside-text">kupos.cl</span> es una plataforma intermediaria de
//             venta de servicios de transporte terrestre. El servicio que se ofrece permite la
//             búsqueda, cotización y compra de distintos servicios y opciones de transporte.<br></br>{' '}
//             Los presentes términos y condiciones (en adelante denominados los{' '}
//             <span className="image-inside-text">“Términos”</span>&nbsp;) representan las condiciones
//             de uso por parte de usted (en adelante el “Usuario”) del sitio web
//             <span className="image-inside-text">'kupos.cl'</span> y nuestra aplicación móvil
//             <span className="image-inside-text">'kupos.cl'</span> (en adelante referidas como{' '}
//             <span className="image-inside-text">"Sitio Web"</span>). Todas las plataformas que
//             conforman el Sitio Web son administradas, operadas y propiedad de{' '}
//             <span className="image-inside-text">Pasajebus SpA</span>.<br></br>
//             <br></br>La lectura previa, entendimiento y aceptación de estos Términos por parte del
//             Usuario es indispensable y obligatorio para el uso de los servicios ofrecidos en el . En
//             caso de que el Usuario no esté de acuerdo con los Términos, no deberá realizar ninguna
//             compra o transacción a través del Sitio Web.<br></br>
//             <br></br> Mediante el uso del Sitio Web, el Usuario manifiesta y deja constancia de su
//             conformidad con los Términos y, además, con las demás políticas relativas al uso del
//             Sitio Web; incluyendo pero sin limitarse a la (i) Política de Privacidad y (ii) Política
//             de Cookies.
//           </div>
//         </div>

//         <div className=" contact-us-item tnc-item">
//           <div className="mt-y-3 font13">
//             <div>
//               <span className="terms-sub-head bold-text">NUESTRO SITIO WEB</span>
//             </div>

//             <div className="pp-section1">
//               <div className="title">
//                 <div className="number-and-text my-3 title">
//                   <div className="primary-circle">1</div>
//                   <span className="bold-text">Condiciones Generales de uso del Sitio Web:</span>
//                 </div>
//               </div>

//               <div className="body-items">
//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">1.1</div>
//                   <span>
//                     El Sitio Web es un agregador en línea que ofrece a los Usuarios la posibilidad
//                     de buscar, cotizar y comprar servicios y opciones de transporte terrestre.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">1.2</div>
//                   <span>
//                     La venta de servicios a través del Sitio Web estará disponible para todas las
//                     personas naturales o jurídicas en condiciones legales para realizar los viajes
//                     contratados.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">1.3</div>
//                   <span>
//                     Para hacer compras utilizando el Sitio Web, el Usuario entiende que debe
//                     ingresar todos los datos necesarios y solicitados por la plataforma para poder
//                     proceder con la transacción.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">1.4</div>
//                   <span>
//                     Al utilizar el Sitio Web, el Usuario autoriza a
//                     <span className="bold-text">kupos.cl</span> y a sus agentes a acceder a sitios
//                     web de terceros, incluyendo pero no limitados a sitios web de bancos y de otras
//                     plataformas de pago, designadas por el banco o en representación del mismo, para
//                     recuperar la información solicitada para el procesamiento de cualquier
//                     transacción generada por el Usuario en el Sitio Web.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">1.5</div>
//                   <span>
//                     Ninguna de las plataformas de <span className="bold-text">kupos.cl</span>{' '}
//                     permite la reserva de servicios. Los pasajes o servicios serán confirmados y
//                     emitidos únicamente cuando se haya confirmado la realización del pago del
//                     Usuario a través de la empresa responsable de gestionar el pago y la
//                     transacción. <span className="bold-text">kupos.cl</span> no tiene injerencia en
//                     los resultados de la relación entre el Usuario y la empresa responsable del
//                     pago, ya que la empresa administra sus operaciones de forma independiente.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">1.6</div>
//                   <span>
//                     <span className="bold-text">kupos.cl</span> aceptará como medio de pago tarjetas
//                     de débito o crédito bancarias emitidas en Chile a través del servicio WebPay
//                     Plus de Transbank S.A., el cual incorpora elementos de seguridad provistos por
//                     TransBank. Clientes extranjeros podrán realizar sus compras en dólares a través
//                     de la plataforma de pago PayPal.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">1.7</div>
//                   <span>
//                     <span className="bold-text">kupos.cl</span> no garantiza que los servicios de la
//                     empresa responsable de los pagos estén libres de errores o fallas en el
//                     funcionamiento. <span className="bold-text">kupos.cl</span> no será responsable
//                     por gestionar el pago en caso de interrupciones o fallas por parte de la empresa
//                     responsable de gestionar el pago.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">1.8</div>
//                   <span>
//                     El uso, condiciones de crédito, intereses y políticas de las tarjetas de crédito
//                     bancarias aplicables a las transacciones realizadas en el Sitio Web son de
//                     exclusiva responsabilidad de su banco emisor, y deben ser gestionadas con la
//                     entidad bancaria correspondiente.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">1.9</div>
//                   <span>
//                     <span className="bold-text">kupos.cl</span> no guarda registro de datos
//                     bancarios. Estos datos son encriptados por Transbank S.A. o PayPal y son estas
//                     últimas quienes certifican la seguridad de la transacción.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">1.10</div>
//                   <span>
//                     En caso de compras en moneda extranjera,{' '}
//                     <span className="bold-text">kupos.cl</span> utiliza una tasa de cambio de pesos
//                     chilenos / dólares americanos de USD700.{' '}
//                     <span className="bold-text">kupos.cl</span> se reserva el derecho de manejar
//                     esta tasa de cambio independiente de la tasa del mercado. Esta tasa es informada
//                     a los usuarios previo al momento del pago y finalización de la transacción.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">1.11</div>
//                   <span>
//                     <span className="bold-text">kupos.cl</span> cuenta con una billetera digital
//                     propia (en adelante referida como “kupospay”), la cual también podrá ser
//                     utilizada para pagar servicios dentro del Sitio Web.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">1.12</div>
//                   <span>
//                     <span className="bold-text">kupos.cl</span> se compromete a mantener el Sitio
//                     Web activo durante las 24 horas del día, excepto cuando exista la imposibilidad
//                     de funcionar por razones de fuerza mayor o por dependencia en servicios
//                     brindados por terceros y que no sean responsabilidad de{' '}
//                     <span className="bold-text">kupos.cl</span>.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">1.13</div>
//                   <span>
//                     El Sitio Web podrá ser usado exclusivamente para fines personales y no para
//                     fines comerciales. El Cliente entiende y acepta que no está autorizado a
//                     revender, utilizar, copiar, monitorizar (por ejemplo, mediante spider, scrape),
//                     desplegar, descargar o reproducir ningún contenido o información, software,
//                     productos o facilidad disponible en el Sitio Web para ninguna actividad,
//                     propósito comercial o competitivo.
//                   </span>
//                 </div>
//               </div>
//             </div>

//             <div className="pp-section2">
//               <div className="title">
//                 <div className="number-and-text my-3 title">
//                   <div className="primary-circle">2</div>
//                   <span className="bold-text">Registro y creación de cuentas de Usuario:</span>
//                 </div>
//               </div>

//               <div className="body-items">
//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">2.1</div>
//                   <span>
//                     <span className="bold-text">kupos.cl</span> ofrece al Usuario la facilidad de
//                     registrar una cuenta personal en el Sitio Web. Dicha cuenta de usuario estará
//                     vinculada con su RUT o número de identificación, dirección de correo electrónico
//                     y número telefónico.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">2.2</div>
//                   <span>
//                     Es de exclusiva responsabilidad del Usuario el mantener la confidencialidad de
//                     su cuenta, su contraseña y de restringir el acceso a su ordenador o dispositivos
//                     con el fin de evitar accesos no autorizados a su cuenta registrada y a su cuenta
//                     kupospay. En caso de tener algún motivo para creer que su contraseña o cuenta
//                     está siendo utilizada por otra persona, es responsabilidad del Usuario el
//                     comunicarse e informar de manera inmediata al equipo de{' '}
//                     <span className="bold-text">kupos.cl</span>.{' '}
//                     <span className="bold-text">kupos.cl</span> no será responsable por pérdidas en
//                     las que el Usuario pueda incurrir debido a accesos o credenciales compartidas de
//                     su cuenta registrada o kupospay.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">2.3</div>
//                   <span>
//                     Es responsabilidad del Usuario el proporcionar a{' '}
//                     <span className="bold-text">kupos.cl</span> datos correctos, exactos y actuales.
//                     En caso de equivocaciones por parte del Usuario,{' '}
//                     <span className="bold-text">kupos.cl</span> no tiene ninguna responsabilidad por
//                     la corrección ni verificación de los datos proporcionados.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">2.4</div>
//                   <span>
//                     En caso de que el Usuario utilice cualquiera de las plataformas de{' '}
//                     <span className="bold-text">kupos.cl</span> a través de una cuenta registrada,
//                     éste acepta la responsabilidad por todas las acciones realizadas desde la misma
//                     y desde su cuenta kupospay.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">2.5</div>
//                   <span>
//                     <span className="bold-text">kupos.cl</span> no será responsable de identificar,
//                     censurar o controlar las transacciones, incluyendo confirmar si la transacción
//                     es legal y/o válida conforme a las leyes y disposiciones vigentes de Chile.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">2.6</div>
//                   <span>
//                     Si la cuenta o transacciones del Usuario muestran señales de fraude, abuso o
//                     actividades sospechosas, <span className="bold-text">kupos.cl</span> puede
//                     cancelar cualquier compra relacionada con su nombre, dirección de correo
//                     electrónico o cuenta, así como denegar el acceso al Sitio Web o bloquear
//                     temporalmente cualquier cuenta abierta en las plataformas de{' '}
//                     <span className="bold-text">kupos.cl</span>. En caso de detectar alguna
//                     actividad fraudulenta,
//                     <span className="bold-text">kupos.cl</span> se reserva el derecho de tomar
//                     cualquier acción legal necesaria contra el Usuario y el Usuario será responsable
//                     de las pérdidas monetarias de <span className="bold-text">kupos.cl</span>,
//                     incluso de los costos de litigación y daños.
//                   </span>
//                 </div>
//               </div>
//             </div>

//             <div className="pp-section3">
//               <div className="title">
//                 <div className="number-and-text my-3 title">
//                   <div className="primary-circle">3</div>
//                   <span className="bold-text">Sobre kupospay:</span>
//                 </div>

//                 <div>
//                   <span>
//                     <span className="bold-text">kupos.cl</span> proporciona a sus usuarios
//                     registrados la facilidad de realizar transacciones mediante saldo o crédito
//                     disponible en su cuenta en línea o billetera virtual, en adelante “kupospay”,
//                     bajo las siguientes condiciones de uso:
//                   </span>
//                 </div>
//               </div>

//               <div className="body-items">
//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">3.1</div>
//                   <span>
//                     El uso de kupospay será exclusivo para los clientes registrados y con cuentas
//                     confirmadas en <span className="bold-text">kupos.cl</span>.
//                   </span>
//                 </div>

//                 <div className="multi-tier">
//                   <div className="number-and-text my-3">
//                     <div className="secondary-circle">3.2</div>
//                     <span>
//                       Para disponer de saldo en kupospay, el Usuario podrá recargar su cuenta en dos
//                       modalidades:
//                     </span>
//                   </div>

//                   <div className="number-and-text my-3 title">
//                     <div className="primary-circle">3.2.1</div>
//                     <span>
//                       3.2.1 Recarga por transferencia bancaria: El Usuario puede recargar su
//                       kupospay transfiriendo el monto que desea recargar a la cuenta bancaria de
//                       <span className="bold-text">kupos.cl</span>.<br></br>{' '}
//                       <span className="bold-text">- Cuenta bancaria:</span> Destinatario: PasajeBus
//                       SpA <br></br> RUT: 76.335.837-2 <br></br> Banco: BancoEstado Cuenta <br></br>
//                       Corriente: 20400001538 <br></br> Correo electrónico: pbcash@pasajebus.com
//                       <br></br>
//                       <br></br>
//                       <span className="bold-text">- Consideraciones importantes:</span>En la recarga
//                       por transferencia bancaria es indispensable que el Usuario ingrese el RUT
//                       asociado a la cuenta a recargar en el comentario de la transacción al momento
//                       de realizar la transferencia. <br></br>
//                       <br></br> En caso de que por error el Usuario no ingrese el RUT de la cuenta a
//                       recargar en el comentarios de la transferencia, el Usuario deberá comunicarse
//                       con el equipo de atención al cliente de{' '}
//                       <span className="bold-text">kupos.cl</span> y la recarga podrá demorarse hasta
//                       48 horas hábiles.
//                     </span>
//                   </div>

//                   <div className="number-and-text my-3 title">
//                     <div className="primary-circle">3.2.2</div>
//                     <span>
//                       Recarga en efectivo: El Usuario puede recargar su kupospay en efectivo
//                       iniciando el proceso en cualquiera de las plataformas de{' '}
//                       <span className="bold-text">kupos.cl</span> y finalizando la recarga en
//                       cualquiera de los puntos autorizados: CajaVecina, ServiEstado, Sencillito y
//                       Multicaja.
//                     </span>
//                   </div>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">3.3</div>
//                   <span>
//                     El Usuario podrá abonar un máximo de CLP$200.000 a su cuenta kupospay utilizando
//                     cualquiera de las modalidades de recarga.
//                   </span>
//                 </div>

//                 <div className="multi-tier">
//                   <div className="number-and-text my-3">
//                     <div className="secondary-circle">3.4</div>
//                     <span>
//                       El crédito abonado a kupospay podrá ser utilizado única y exclusivamente para
//                       compra de pasajes o servicios en cualquiera de las plataformas de{' '}
//                       <span className="bold-text">kupos.cl</span>:
//                     </span>
//                   </div>

//                   <div className="number-and-text my-3 title">
//                     <div className="primary-circle">3.4.1</div>
//                     <span>
//                       En caso de no contar con saldo suficiente para pagar el total de la compra, el
//                       Usuario no podrá combinar distintos métodos de pago, utilizando el saldo
//                       disponible en su cuenta kupospay para pagar una parte del monto y cubrir la
//                       diferencia con otro método de pago.
//                     </span>
//                   </div>

//                   <div className="number-and-text my-3 title">
//                     <div className="primary-circle">3.4.2</div>
//                     <span>
//                       En caso de comprar un pasaje o servicio por un valor inferior al crédito
//                       disponible en su cuenta kupospay, se cargará el monto total de la transacción
//                       al saldo disponible y la diferencia se mantendrá en la cuenta kupospay del
//                       Usuario como saldo para futuras compras.
//                     </span>
//                   </div>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">3.5</div>
//                   <span>
//                     El Usuario podrá cancelar boletos adquiridos en las plataformas de{' '}
//                     <span className="bold-text">kupos.cl</span> y solicitar la devolución del monto
//                     correspondiente como saldo en su cuenta kupospay.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">3.6</div>
//                   <span>
//                     Compras realizadas en cualquiera de las plataformas de{' '}
//                     <span className="bold-text">kupos.cl</span> y pagadas con saldo disponible en
//                     cuentas kupospay, solo tendrán disponible la devolución en su cuenta kupospay.
//                     Bajo ninguna circunstancia se hará devolución de dinero a cuentas bancarias si
//                     el pasaje fue pagado con saldo de la cuenta kupospay del Usuario.
//                   </span>
//                 </div>

//                 <div className="multi-tier">
//                   <div className="number-and-text my-3">
//                     <div className="secondary-circle">3.7</div>
//                     <span>
//                       El Usuario podrá transferir saldo a otras cuentas registradas y confirmadas en
//                       <span className="bold-text">kupos.cl</span>. Será de exclusiva responsabilidad
//                       del Usuario el proporcionar los datos correctos y exactos de la cuenta a la
//                       que desea transferir, así como su verificación al momento de transferirlos.{' '}
//                       <span className="bold-text">kupos.cl</span> no se hace responsable en caso de
//                       errores al momento de ingresar los datos para las transferencias entre
//                       cuentas.
//                     </span>
//                   </div>

//                   <div className="number-and-text my-3 title">
//                     <div className="primary-circle">3.7.1</div>
//                     <span>
//                       El Usuario podrá transferir un monto máximo de CLP$200.000 a otras cuentas
//                       registradas en <span className="bold-text">kupos.cl</span>.
//                     </span>
//                   </div>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">3.8</div>
//                   <span>
//                     Cualquier monto recargado en cuentas kupospay, sea en efectivo o por
//                     transferencia, sólo podrá ser utilizado dentro de la plataformas de{' '}
//                     <span className="bold-text">kupos.cl</span> y bajo ninguna circunstancia será
//                     reembolsable o podrá ser transferido a ninguna cuenta bancaria del titular de la
//                     cuenta.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">3.9</div>
//                   <span>
//                     Cualquier saldo existente en la cuenta kupospay del Usuario y que permanezca sin
//                     uso y sin ser reclamado por un plazo superior a un (1) año, será bloqueado y no
//                     podrá ser reclamado ni restaurado en ninguna cuenta kupospay.
//                   </span>
//                 </div>
//               </div>
//             </div>

//             <div className="pp-section4">
//               <div className="title">
//                 <div className="number-and-text my-3 title">
//                   <div className="primary-circle">4</div>
//                   <span className="bold-text">Promociones y descuentos:</span>
//                 </div>
//               </div>

//               <div className="body-items">
//                 <div className="multi-tier">
//                   <div className="number-and-text my-3">
//                     <div className="secondary-circle">4.1</div>
//                     <span>
//                       Saldo promocional: Se entenderá como ‘Saldo Promocional’ al saldo recibido por
//                       el Usuario en su kupospay por concepto de promociones o concursos especiales
//                       de <span className="bold-text">kupos.cl</span>. El Usuario hace de su
//                       conocimiento que:
//                     </span>
//                   </div>

//                   <div className="number-and-text my-3 title">
//                     <div className="primary-circle">4.1.1</div>
//                     <span>
//                       En caso de recibir Saldo Promocional en su cuenta kupospay por concepto de
//                       promociones o concursos especiales de{' '}
//                       <span className="bold-text">kupos.cl</span>, este Saldo Promocional se regirá
//                       en función de los términos y condiciones específicos de cada concurso o
//                       promoción.
//                     </span>
//                   </div>

//                   <div className="number-and-text my-3 title">
//                     <div className="primary-circle">4.1.2</div>
//                     <span>
//                       El Saldo Promocional tendrá una vigencia y fecha de expiración a partir de la
//                       cual no estará disponible para ser utilizado por el Usuario.
//                     </span>
//                   </div>

//                   <div className="number-and-text my-3 title">
//                     <div className="primary-circle">4.1.3</div>
//                     <span>
//                       Es de exclusiva responsabilidad del Usuario la utilización del Saldo
//                       Promocional dentro de su vigencia correspondiente y no habrá posibilidad de
//                       extensión del plazo en caso de no haber sido utilizado.
//                     </span>
//                   </div>
//                 </div>

//                 <div className="multi-tier">
//                   <div className="number-and-text my-3">
//                     <div className="secondary-circle">4.2</div>
//                     <span>Convenios promocionales activos:</span>
//                   </div>

//                   <div className="number-and-text my-3 title">
//                     <div className="primary-circle">4.2.1</div>
//                     <span>Caja Los Héroes:</span>
//                   </div>

//                   <div className="number-and-text my-3 title" style={{ marginLeft: 80 }}>
//                     <div className="secondary-circle" style={{ width: 40, height: 40 }}>
//                       4.2.1.1
//                     </div>
//                     <span>
//                       <span className="bold-text">kupos.cl</span> otorga un 5% de descuento a los
//                       clientes afiliados de CCAF Los Héroes que validen su condición de afiliado con
//                       su número de cédula de identidad o RUT vigente.{' '}
//                     </span>
//                   </div>
//                   <div className="number-and-text my-3 title" style={{ marginLeft: 80 }}>
//                     <div className="secondary-circle" style={{ width: 40, height: 40 }}>
//                       4.2.1.2
//                     </div>
//                     <span>
//                       Para acceder al descuento, el afiliado deberá ingresar su número de RUT como
//                       código promocional al momento de hacer la compra.
//                     </span>
//                   </div>
//                   <div className="number-and-text my-3 title" style={{ marginLeft: 80 }}>
//                     <div className="secondary-circle" style={{ width: 40, height: 40 }}>
//                       4.2.1.3
//                     </div>
//                     <span>
//                       Promoción exclusiva para afiliados activos de CCAF y para compras realizadas
//                       únicamente desde la app móvil de <span className="bold-text">kupos.cl</span>.
//                     </span>
//                   </div>
//                   <div className="number-and-text my-3 title" style={{ marginLeft: 80 }}>
//                     <div className="secondary-circle" style={{ width: 40, height: 40 }}>
//                       4.2.1.4
//                     </div>
//                     <span>
//                       Promoción no acumulable con otras promociones y/o descuentos. Promoción válida
//                       hasta agotar el presupuesto mensual asignado.
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="pp-section5">
//               <div className="title">
//                 <div className="number-and-text my-3 title">
//                   <div className="primary-circle">5</div>
//                   <span className="bold-text">Sobre dudas, reclamos o servicio de atención al cliente:</span>
//                 </div>
//               </div>

//               <div className="body-items">
//                 <div className="multi-tier">
//                   <div className="number-and-text my-3">
//                     <div className="secondary-circle">5.1</div>
//                     <span>
//                       En caso de dudas, reclamos o necesidad de soporte para compras, cancelaciones
//                       o cualquier problema de uso en cualquiera de las plataformas del Sitio Web,
//                       <span className="bold-text">kupos.cl</span> dispone de los siguientes canales
//                       de atención, disponibles de Lunes a Domingo en los horarios indicados a
//                       continuación:
//                     </span>
//                   </div>

//                   {/* <div className="number-and-text my-3 title">
//                     <div className="primary-circle">5.1.1</div>
//                     <span>
//                       <span className="bold-text">Canales de atención:</span> <br></br>
//                       <br></br>
//                       Correo electrónico: ayuda@<span className="bold-text"> <span className="bold-text">kupos.cl</span></span>
//                       <br></br>
//                       WhatsApp: +56 9 4915 6683<br></br>
//                       Teléfono: +56 9 4915 6683 <br></br>
//                     </span>
//                   </div> */}

//                   <div></div>

//                   <div className="multi-tier" style={{ marginLeft: 40 }}>
//                     <div className="number-and-text my-3 ">
//                       <div className="primary-circle">5.1.1</div>
//                       <span>
//                         <span className="bold-text">Canales de atención:</span> <br></br>
//                         {/* <br></br>
//                       Lunes a Viernes: De 8:00 AM a 01:00 AM. <br></br>
//                       Sábados, domingos y feriados: De 9:00AM a 22:00PM. */}
//                       </span>
//                     </div>
//                     <div className="number-and-text my-3 title">
//                       <div className="secondary-circle" style={{ width: 40, height: 40 }}>
//                         5.1.1.1
//                       </div>
//                       <span>
//                         Correo electrónico: ayuda@
//                         <span className="bold-text">
//                           {' '}
//                           <span className="bold-text">kupos.cl</span>
//                         </span>
//                       </span>
//                     </div>
//                     <div className="number-and-text my-3 title" style={{ marginLeft: 80 }}>
//                       <div className="secondary-circle" style={{ width: 40, height: 40 }}>
//                         5.1.1.2
//                       </div>
//                       <span>WhatsApp: +56 9 4915 6683</span>
//                     </div>
//                     <div className="number-and-text my-3 title" style={{ marginLeft: 80 }}>
//                       <div className="secondary-circle" style={{ width: 40, height: 40 }}>
//                         5.1.1.3
//                       </div>
//                       <span>Teléfono: +56 9 4915 6683</span>
//                     </div>

//                     <div className="number-and-text my-3 title" style={{ marginLeft: 80 }}>
//                       <div className="secondary-circle" style={{ width: 40, height: 40 }}>
//                         5.1.1.4
//                       </div>
//                       <span>
//                         Chat en línea en{' '}
//                         <span className="bold-text">
//                           {' '}
//                           <span className="bold-text">kupos.cl</span>
//                         </span>
//                       </span>
//                     </div>
//                   </div>

//                   <div className="number-and-text my-3 " style={{ marginLeft: 40 }}>
//                     <div className="primary-circle">5.1.2</div>
//                     <span>
//                       <span className="bold-text">Horarios de atención:</span> <br></br>
//                       {/* <br></br>
//                       Lunes a Viernes: De 8:00 AM a 01:00 AM. <br></br>
//                       Sábados, domingos y feriados: De 9:00AM a 22:00PM. */}
//                     </span>
//                   </div>
//                   <div className="number-and-text my-3 title" style={{ marginLeft: 80 }}>
//                     <div className="secondary-circle" style={{ width: 40, height: 40 }}>
//                       5.1.2.1
//                     </div>
//                     <span>
//                     Lunes a Viernes: De 8:00 AM a 23:30 PM.<br></br>
//                     </span>
//                   </div>
//                   <div className="number-and-text my-3 title" style={{ marginLeft: 80 }}>
//                     <div className="secondary-circle" style={{ width: 40, height: 40 }}>
//                       5.1.2.2
//                     </div>
//                     <span>Sábados, domingos y feriados: De 9:00AM a 19:00PM.</span>
//                   </div>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">5.2</div>
//                   <span>
//                     El Cliente dispone de un plazo máximo de tres (3) meses para hacer reclamos por
//                     servicios adquiridos en cualquiera de las plataformas de{' '}
//                     <span className="bold-text">kupos.cl</span>. El plazo de tres (3) comienza a
//                     contar a partir de la fecha de cumplimiento del servicio, en este caso, fecha de
//                     viaje. Una vez transcurrido este período, el Cliente pierde el derecho a
//                     reclamar por cualquier incumplimiento o inconformidad que tenga con el servicio
//                     en cuestión.
//                   </span>
//                 </div>
//               </div>
//             </div>

//             {/* </div> closing bracket main inner */}
//           </div>

//           <div className="mt-y-3 font13">
//             <div>
//               <span className="terms-sub-head bold-text">SERVICIO DE BUSES INTERURBANOS:</span>
//             </div>

//             <div className="pp-section1">
//               <div className="title">
//                 <div className="number-and-text my-3 title">
//                   <div className="primary-circle">6</div>
//                   <span className="bold-text">
//                     Condiciones generales del servicio de buses interurbanos:
//                   </span>
//                 </div>
//               </div>

//               <div className="body-items">
//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">6.1</div>
//                   <span>
//                     <span className="bold-text">kupos.cl</span> es un agregador en línea de empresas
//                     de buses que conecta al Usuario con operadores o empresas de buses, siendo un
//                     intermediario a través de su Sitio Web en la venta en línea de pasajes de las
//                     empresas de buses
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">6.2</div>
//                   <span>
//                     En vista de lo anterior, el Usuario acepta y hace de su conocimiento que
//                     <span className="bold-text">kupos.cl</span> no realiza ni presta el servicio de
//                     transporte de pasajeros, por lo que no le corresponde ninguna responsabilidad
//                     por el servicio de transporte prestado ni por los inconvenientes que pudieran
//                     presentarse durante el servicio adquirido, incluyendo pero no limitado a:
//                     emisión incorrecta de boletos; retrasos en la hora de los servicios o desvíos no
//                     planificados; cambios en los paraderos, puntos de embarque o destinos;
//                     cancelación o suspensión de servicios por parte de la empresa prestadora del
//                     servicio; extravíos o daños en el equipaje; accidentes de viajes; cambios de
//                     asientos, buses, etc. o cualquier otro daño que no corresponda al servicio
//                     prestado por <span className="bold-text">kupos.cl</span>.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">6.3</div>
//                   <span>
//                     <span className="bold-text">kupos.cl</span> limitará las compras de pasajes
//                     dependiendo de la disponibilidad de servicios y de los asientos disponibles de
//                     acuerdo a la información proporcionada por las empresas de buses. El Usuario
//                     entiende y acepta que la información mostrada por{' '}
//                     <span className="bold-text">kupos.cl</span> en el Sitio Web en relación a los
//                     servicios de transporte ofertados es proporcionada directa y exclusivamente por
//                     las empresas de buses.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">6.4</div>
//                   <span>
//                     Las tarifas mostradas por <span className="bold-text">kupos.cl</span> en su
//                     sitio web son exclusivas para los tramos señalados y para pasajes confirmados
//                     asociados a una hora, fecha y asiento específico. Los precios son definidos por
//                     la empresa de bus prestadora del servicio y están sujetos a cambios sin previo
//                     aviso
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">6.5</div>
//                   <span>
//                     Las compras de pasajes a través del Sitio Web son válidas única y exclusivamente
//                     para la fecha, hora y asiento del servicio seleccionado por el Usuario al
//                     momento de efectuar la transacción. <span className="bold-text">kupos.cl</span>{' '}
//                     no será responsable por errores de parte del Usuario al momento de ingresar los
//                     datos para el procesamiento de la compra.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">6.6</div>
//                   <span>
//                     El Usuario entiende y acepta que debe ingresar datos personales correctos y
//                     válidos al momento de realizar la compra. Estos mismos datos serán utilizados en
//                     la emisión del pasaje, el cual debe incluir nombre completo y número de RUT o de
//                     documento de identificación válido del pasajero que viajará. Es responsabilidad
//                     del Usuario el demostrar la validez de sus datos en caso de ser requerido.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">6.7</div>
//                   <span>
//                     En ningún caso se permitirá cambio en la fecha u hora del viaje, datos
//                     personales, asientos, ni ninguna otra información que afecte la compra ya
//                     realizada y confirmada por el Usuario. En caso de ocurrir alguno de los errores
//                     mencionados previamente, el Usuario deberá proceder con la anulación del pasaje
//                     y realizar una nueva compra.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">6.8</div>
//                   <span>
//                     La confirmación de compra será enviada de forma inmediata al correo electrónico
//                     registrado por el Usuario al momento de la compra, siempre que se confirme el
//                     pago correspondiente a la transacción. Esta confirmación de compra contendrá los
//                     datos de los pasajeros registrados por el Usuario, así como detalles del
//                     servicio contratado, tal como compañía de buses, fecha de viaje, horario de
//                     salida y monto de la transacción.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">6.9</div>
//                   <span>
//                     El comprobante enviado en la confirmación de compra indicará las instrucciones a
//                     seguir por el Usuario en cuanto a la impresión y presentación del boleto, para
//                     poder ocupar el servicio contratado. Estas instrucciones varían dependiendo de
//                     la empresa de buses prestadora del servicio.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">6.10</div>
//                   <span>
//                     El Usuario será responsable de presentarse en el terminal o paradero de embarque
//                     correspondiente al menos veinte (20) minutos antes de la hora de salida del bus.
//                     Este tiempo puede variar dependiendo de la empresa de buses prestadora del
//                     servicio.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">6.11</div>
//                   <span>
//                     El Usuario solo podrá abordar el bus en el punto de embarque indicado al momento
//                     de hacer la compra y reflejado en el pasaje. Una vez confirmado el pasaje, el
//                     Usuario no podrá cambiar el punto de embarque.
//                   </span>
//                 </div>

//                 <div className="multi-tier">
//                   <div className="number-and-text my-3">
//                     <div className="secondary-circle">6.12</div>
//                     <span>
//                       La presentación del pasaje impreso o en electrónico, en caso de que así se
//                       indique, es de carácter obligatorio y será responsabilidad del Usuario el
//                       tenerlo en el formato solicitado por la empresa prestadora del servicio. En
//                       caso de que el Usuario no disponga del pasaje en el formato indicado a la hora
//                       de salida del bus, quedará a criterio de la empresa de bus el permitir o no al
//                       Usuario el realizar el viaje. <span className="bold-text">kupos.cl</span> no
//                       tendrá ninguna responsabilidad en caso de que la empresa no permita al Usuario
//                       subir al bus. <span className="bold-text">kupos.cl</span> tampoco será
//                       responsable por la pérdida, hurto, extravío o mal uso del pasaje de
//                       confirmación.
//                     </span>
//                   </div>

//                   <div className="number-and-text my-3 title">
//                     <div className="primary-circle">6.12.1</div>
//                     <span>
//                       En caso de requerir el pasaje impreso, el servicio de impresión no podrá ser
//                       realizado en el terminal ni en ventanillas del operador de bus.
//                     </span>
//                   </div>

//                   <div className="number-and-text my-3 title">
//                     <div className="primary-circle">6.12.2</div>
//                     <span>
//                       En caso de que sea requerido pasar por la ventanilla del operador de bus para
//                       retirar el boleto para abordar el bus, es responsabilidad del Usuario disponer
//                       del tiempo necesario para poder realizar este paso y estar en el andén con
//                       tiempo suficiente antes de la salida del bus.
//                     </span>
//                   </div>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">6.13</div>
//                   <span>
//                     En caso de contratar servicios de viajes internacionales, es responsabilidad del
//                     Usuario el cumplir con las exigencias requeridas por el país de destino para
//                     asegurar su ingreso según lo programado (documentos, vacunas, permisos, objetos
//                     prohibidos, otros).
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">6.14</div>
//                   <span>
//                     En función de lo anterior y en caso de ser negado el ingreso en el país de
//                     destino, <span className="bold-text">kupos.cl</span> no tendrá la obligación de
//                     otorgar devoluciones parciales ni totales del importe del pasaje, ni tampoco
//                     hacer cambios de fechas en los pasajes ya adquiridos.
//                   </span>
//                 </div>

//                 {/* body closing tag */}
//               </div>

//               {/* section tag closing */}
//             </div>

//             <div className="pp-section2">
//               <div className="title">
//                 <div className="number-and-text my-3 title">
//                   <div className="primary-circle">7</div>
//                   <span className="bold-text">Sobre cancelación de boletos:</span>
//                 </div>
//               </div>

//               <div className="body-items">
//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">7.1</div>
//                   <span>
//                     La cancelación o anulación de servicios adquiridos a través del Sitio Web debe
//                     ser procesada en línea, únicamente en las plataformas de{' '}
//                     <span className="bold-text">kupos.cl</span>.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">7.2</div>
//                   <span>
//                     El número de reserva y la confirmación de compra es el único documento válido
//                     para solicitar anulaciones de pasajes en{' '}
//                     <span className="bold-text">kupos.cl</span>.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">7.3</div>
//                   <span>
//                     Las cancelaciones totales o parciales del servicio contratado sólo podrán ser
//                     procesadas hasta cuatro (4) horas antes de la hora de salida del bus. Esto
//                     podría implicar la retención de hasta un 15% del valor del pasaje, cumpliendo
//                     así con el Art. 67 D.S. 212 del 15/10/1992 MTT. La aplicación de la retención o
//                     el porcentaje exacto dependerá del operador de buses prestador del servicio.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">7.4</div>
//                   <span>
//                     Intentos de cancelación o anulación dentro de las cuatro (4) horas previas a la
//                     hora de salida del bus no serán procesadas y no les corresponde devolución de
//                     dinero.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">7.5</div>
//                   <span>
//                     Políticas de cancelación para viajes internacionales pueden variar, aumentando
//                     el porcentaje de retención y las horas permitidas de cancelación.
//                   </span>
//                 </div>

//                 <div className="multi-tier">
//                   <div className="number-and-text my-3">
//                     <div className="secondary-circle">7.6</div>
//                     <span>
//                       Al cancelar un pasaje, el Usuario tendrá las siguientes opciones de reembolso:
//                     </span>
//                   </div>

//                   <div className="number-and-text my-3 title">
//                     <div className="primary-circle">7.6.1</div>
//                     <span>
//                       Depósito en cuenta bancaria: Solo válido para cuentas bancarias chilenas.
//                       Procesado entre siete (7) y diez (10) días hábiles.
//                     </span>
//                   </div>

//                   <div className="number-and-text my-3 title">
//                     <div className="primary-circle">7.6.2</div>
//                     <span>
//                       PPayPal: Solo válido para Usuarios que hayan procesado su compra utilizando
//                       PayPal como medio de pago. Procesado entre siete (7) y diez (10) días hábiles.
//                     </span>
//                   </div>

//                   <div className="number-and-text my-3 title">
//                     <div className="primary-circle">7.6.3</div>
//                     <span>
//                       Tarjeta de crédito: Solo válido para Usuarios que hayan procesado su compra
//                       utilizando Tarjeta de Crédito como medio de pago. Procesado entre siete (7) y
//                       diez (10) días hábiles.
//                     </span>
//                   </div>

//                   <div className="number-and-text my-3 title">
//                     <div className="primary-circle">7.6.4</div>
//                     <span>
//                       kupospay: Solo válido para Usuarios registrados y con cuenta verificada en
//                       <span className="bold-text">kupos.cl</span>. El reembolso se abona como saldo
//                       disponible en la cuenta kupospay del Usuario para futuras compras en el Sitio
//                       Web o cualquiera de las plataformas de{' '}
//                       <span className="bold-text">kupos.cl</span>.
//                     </span>
//                   </div>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">7.7</div>
//                   <span>
//                     Las cancelaciones de pasajes tendrán un cargo adicional de CLP$600 por cada
//                     transacción anulada, por concepto de gastos administrativos y bancarios.
//                     Reembolsos solicitados a kupospay no tendrán cargos adicionales de cancelación.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">7.8</div>
//                   <span>
//                     Una vez procesada la cancelación por parte del Usuario, no se permitirá cambio
//                     en el tipo de reembolso seleccionado.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">7.9</div>
//                   <span>
//                     En caso de errores en los datos provistos por el Usuario al momento de procesar
//                     la anulación, <span className="bold-text">kupos.cl</span> solicitará al Usuario
//                     nuevamente la corrección de los datos proporcionados y el reembolso será
//                     procesado en un período de entre siete (7) y diez (10) días hábiles, a contar
//                     desde el día de recepción de los datos corregidos.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">7.10</div>
//                   <span>
//                     En caso de que <span className="bold-text">kupos.cl</span> no reciba los datos
//                     solicitados al Usuario en un plazo de de tres meses desde la primera
//                     comunicación, el Usuario perderá su derecho a reembolso, entendiéndose que el
//                     servicio se ha prestado y que el dinero se ha pagado por concepto de precio del
//                     mismo.
//                   </span>
//                 </div>
//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">7.11</div>
//                   <span>
//                     La confirmación de la cancelación será enviada a la cuenta de correo electrónico
//                     registrada durante la compra. Esta confirmación contendrá los datos de la
//                     cancelación como número de reserva anulado, monto de retención en caso de que
//                     corresponda, monto total a devolver y tipo de reembolso seleccionado.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">7.12</div>
//                   <span>
//                     No son permitidas cancelaciones de servicios ya prestados o cuya ruta ya haya
//                     iniciado.
//                   </span>
//                 </div>
//               </div>
//             </div>

//             {/* </div> closing bracket main inner */}
//           </div>

//           <div className="mt-y-3 font13">
//             <div>
//               <span className="terms-sub-head bold-text">SERVICIO DE TRENES:</span>
//             </div>

//             <div className="pp-section1">
//               <div className="title">
//                 <div className="number-and-text my-3 title">
//                   <div className="primary-circle">8</div>
//                   <span className="bold-text">Condiciones generales del servicio de trenes:</span>
//                 </div>
//               </div>

//               <div className="body-items">
//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">8.1</div>
//                   <span>
//                     <span className="bold-text">kupos.cl</span> es un agregador en línea de
//                     servicios de transporte que conecta al Usuario con operadores de trenes, siendo
//                     un intermediario a través de su Sitio Web en la venta en línea de pasajes de
//                     cada una de las empresas prestadoras de servicio y sus subsidiarias.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">8.2</div>
//                   <span>
//                     En vista de lo anterior, el Usuario acepta y hace de su conocimiento que
//                     <span className="bold-text">kupos.cl</span> no realiza ni presta el servicio de
//                     transporte de pasajeros, por lo que no le corresponde ninguna responsabilidad
//                     por el servicio de transporte prestado ni por los inconvenientes que pudieran
//                     presentarse durante el servicio adquirido, incluyendo pero no limitado a:
//                     emisión incorrecta de boletos; retrasos en la hora de los servicios; cancelación
//                     o suspensión de servicios por parte de la empresa prestadora del servicio;
//                     extravíos o daños en el equipaje; accidentes de viajes; cambios de asientos,
//                     etc. o cualquier otro daño que no corresponda al servicio prestado por{' '}
//                     <span className="bold-text">kupos.cl</span>.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">8.3</div>
//                   <span>
//                     <span className="bold-text">kupos.cl</span> limitará las compras de pasajes
//                     dependiendo de la disponibilidad de servicios y de los asientos disponibles de
//                     acuerdo a la información proporcionada por las empresas prestadoras del
//                     servicio. El Usuario entiende y acepta que la información mostrada por{' '}
//                     <span className="bold-text">kupos.cl</span> en el Sitio Web en relación a los
//                     servicios de transporte ofertados es proporcionada directa y exclusivamente por
//                     las empresas prestadoras del servicio.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">8.4</div>
//                   <span>
//                     Las tarifas mostradas por <span className="bold-text">kupos.cl</span> en su
//                     sitio web son exclusivas para los tramos señalados y para pasajes confirmados
//                     asociados a una hora, fecha y asiento específico. Los precios son definidos por
//                     la empresa prestadora del servicio y están sujetos a cambios sin previo aviso.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">8.5</div>
//                   <span>
//                     Las compras de pasajes a través del Sitio Web son válidas única y exclusivamente
//                     para la fecha, hora y asiento del servicio seleccionado por el Usuario al
//                     momento de efectuar la transacción. <span className="bold-text">kupos.cl</span>{' '}
//                     no será responsable por errores de parte del Usuario al momento de ingresar los
//                     datos para el procesamiento de la compra.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">8.6</div>
//                   <span>
//                     El Usuario entiende y acepta que debe ingresar datos personales correctos y
//                     válidos al momento de realizar la compra. Estos mismos datos serán utilizados en
//                     la emisión del pasaje, el cual debe incluir nombre completo y número de RUT o de
//                     documento de identificación válido del pasajero que viajará. Es responsabilidad
//                     del Usuario el demostrar la validez de sus datos en caso de ser requerido.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">8.7</div>
//                   <span>
//                     La confirmación de compra será enviada de forma inmediata al correo electrónico
//                     registrado por el Usuario al momento de la compra, siempre que se confirme el
//                     pago correspondiente a la transacción. Esta confirmación de compra contendrá los
//                     datos de los pasajeros registrados por el Usuario, así como detalles del
//                     servicio contratado, tal como empresa prestadora, número de pasaje, fecha de
//                     viaje, horario de salida y monto de la transacción.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">8.8</div>
//                   <span>
//                     El comprobante enviado en la confirmación de compra indicará las instrucciones a
//                     seguir por el Usuario en cuanto a la impresión y presentación del boleto, para
//                     poder ocupar el servicio contratado.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">8.9</div>
//                   <span>
//                     El Usuario será responsable de presentarse en la estación de tren
//                     correspondiente al menos treinta (30) minutos antes de la hora de salida del
//                     viaje.
//                   </span>
//                 </div>

//                 <div className="multi-tier">
//                   <div className="number-and-text my-3">
//                     <div className="secondary-circle">8.10</div>
//                     <span>
//                       La presentación del pasaje impreso o en electrónico, en caso de que así se
//                       indique, es de carácter obligatorio y será responsabilidad del Usuario el
//                       tenerlo en el formato solicitado por la empresa prestadora del servicio. En
//                       caso de que el Usuario no disponga del pasaje en el formato indicado a la hora
//                       de salida del tren, quedará a criterio de la empresa el permitir o no al
//                       Usuario el realizar el viaje. <span className="bold-text">kupos.cl</span> no
//                       tendrá ninguna responsabilidad en caso de que la empresa no permita al Usuario
//                       subir al tren. <span className="bold-text">kupos.cl</span> tampoco será
//                       responsable por la pérdida, hurto, extravío o mal uso del pasaje de
//                       confirmación.
//                     </span>
//                   </div>

//                   <div className="number-and-text my-3 title">
//                     <div className="primary-circle">8.10.1</div>
//                     <span>
//                       En caso de no tener cómo mostrar el pasaje impreso o en digital, será
//                       responsabilidad del Usuario disponer del tiempo necesario para poder acercarse
//                       a las boleterías del servicio Alameda - Chillán de TrenCentral para solicitar
//                       de forma excepcional la reimpresión del boleto.
//                     </span>
//                   </div>
//                 </div>

//                 {/* body closing tag */}
//               </div>

//               {/* section tag closing */}
//             </div>

//             <div className="pp-section5">
//               <div className="title">
//                 <div className="number-and-text my-3 title">
//                   <div className="primary-circle">9</div>
//                   <span className="bold-text">Sobre cambios de boletos:</span>
//                 </div>
//               </div>

//               <div className="body-items">
//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">9.1</div>
//                   <span>
//                     Los cambios en los boletos están permitidos únicamente hasta dos (2) horas antes
//                     de la hora de salida del viaje.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">9.2</div>
//                   <span>
//                     Los cambios en los boletos pueden ser gestionados vía telefónica con el Servicio
//                     de Atención Telefónica de TrenCentral únicamente cuando no hay diferencia
//                     tarifaria o de precios en los servicios. En caso de que la tarifa se vea
//                     afectada, los cambios deben ser gestionados única y exclusivamente en las
//                     boleterías del servicio Alameda - Chillán de TrenCentral.
//                   </span>
//                 </div>
//               </div>
//             </div>

//             <div className="pp-section5">
//               <div className="title">
//                 <div className="number-and-text my-3 title">
//                   <div className="primary-circle">10</div>
//                   <span className="bold-text">Sobre cancelaciones de boletos:</span>
//                 </div>
//               </div>

//               <div className="body-items">
//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">10.1</div>
//                   <span>
//                     Las cancelaciones o devolución de boletos sólo podrán ser procesadas hasta dos
//                     (2) horas antes de la hora de salida del viaje, únicamente en las boleterías
//                     habilitadas y en los horarios establecidos por TrenCentral.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">10.2</div>
//                   <span>
//                     Las cancelaciones o devolución de boletos implican la retención de un 30% del
//                     valor del boleto; por lo que el Usuario recibirá un 70% del valor del pasaje.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">10.3</div>
//                   <span>
//                     Boletos promocionales o promocionales sin venta no permiten cambio de fecha /
//                     hora, ni devoluciones.
//                   </span>
//                 </div>
//               </div>
//             </div>

//             {/* </div> closing bracket main inner */}
//           </div>

//           <div className="mt-y-3 font13">
//             <div>
//               <span className="terms-sub-head bold-text">SERVICIO DE TRANSFER AEROPUERTO</span>
//             </div>

//             <div className="pp-section1">
//               <div className="title">
//                 <div className="number-and-text my-3 title">
//                   <div className="primary-circle">11</div>
//                   <span className="bold-text">
//                     Condiciones generales del servicio de transfer al aeropuerto:
//                   </span>
//                 </div>
//               </div>

//               <div className="body-items">
//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">11.1</div>
//                   <span>
//                     <span className="bold-text">kupos.cl</span> es un agregador en línea de
//                     servicios de transporte que conecta al Usuario con operadores de transfer al
//                     aeropuerto, siendo un intermediario a través de su Sitio Web en la venta en
//                     línea de servicios de cada una de las empresas prestadoras de servicio y sus
//                     subsidiarias.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">11.2</div>
//                   <span>
//                     En vista de lo anterior, el Usuario acepta y hace de su conocimiento que
//                     <span className="bold-text">kupos.cl</span> no realiza ni presta el servicio de
//                     transporte de pasajeros, por lo que no le corresponde ninguna responsabilidad
//                     por el servicio de transporte prestado ni por los inconvenientes que pudieran
//                     presentarse durante el servicio adquirido, incluyendo pero no limitado a:
//                     retrasos en la hora de los servicios; cancelación o suspensión de servicios por
//                     parte de la empresa prestadora del servicio; extravíos o daños en el equipaje;
//                     accidentes de viajes; cambios de vehículos, etc. o cualquier otro daño que no
//                     corresponda al servicio prestado por <span className="bold-text">kupos.cl</span>
//                     .
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">11.3</div>
//                   <span>
//                     <span className="bold-text">kupos.cl</span> limitará las compras de servicios
//                     dependiendo de la disponibilidad de servicios y de los asientos disponibles de
//                     acuerdo a la información proporcionada por las empresas prestadoras del
//                     servicio. El Usuario entiende y acepta que la información mostrada por{' '}
//                     <span className="bold-text">kupos.cl</span> en el Sitio Web en relación a los
//                     servicios de transporte ofertados es proporcionada directa y exclusivamente por
//                     las empresas prestadoras del servicio.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">11.4</div>
//                   <span>
//                     Las tarifas mostradas por <span className="bold-text">kupos.cl</span> en su
//                     sitio web son exclusivas para los tramos señalados y para servicios confirmados
//                     asociados a una hora, fecha y tipo de servicio específico. Los precios son
//                     definidos por la empresa prestadora del servicio y están sujetos a cambios sin
//                     previo aviso.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">11.5</div>
//                   <span>
//                     Las compras de pasajes a través del Sitio Web son válidas única y exclusivamente
//                     para la fecha, hora y asiento del servicio seleccionado por el Usuario al
//                     momento de efectuar la transacción. <span className="bold-text">kupos.cl</span>{' '}
//                     no será responsable por errores de parte del Usuario al momento de ingresar los
//                     datos para el procesamiento de la compra.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">11.6</div>
//                   <span>
//                     El Usuario entiende y acepta que debe ingresar datos personales correctos y
//                     válidos al momento de realizar la compra. Estos mismos datos serán utilizados en
//                     la emisión del pasaje, el cual debe incluir nombre completo y número de RUT o de
//                     documento de identificación válido del Usuario que viajará. Es responsabilidad
//                     del Usuario el demostrar la validez de sus datos en caso de ser requerido.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">11.7</div>
//                   <span>
//                     La confirmación de compra será enviada de forma inmediata al correo electrónico
//                     registrado por el Usuario al momento de la compra, siempre que se confirme el
//                     pago correspondiente a la transacción. Esta confirmación de compra contendrá los
//                     datos de los pasajeros registrados por el Usuario, así como detalles del
//                     servicio contratado, tal como empresa prestadora, número de pasaje, fecha de
//                     viaje, horario de salida y monto de la transacción.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">11.8</div>
//                   <span>
//                     El comprobante enviado en la confirmación de compra indicará las instrucciones a
//                     seguir por el Usuario en cuanto a la impresión y presentación del boleto, para
//                     poder ocupar el servicio contratado.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">11.9</div>
//                   <span>
//                     El Usuario será responsable de presentarse en el lugar de recogida al menos
//                     cinco (5) minutos antes de la hora de salida del viaje. En caso de que el
//                     Usuario no se presente a viajar, llegue tarde o esté a destiempo, perderá su
//                     reserva.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">11.10</div>
//                   <span>
//                     La presentación del pasaje impreso o en electrónico, en caso de que así se
//                     indique, es de carácter obligatorio y será responsabilidad del Usuario el
//                     tenerlo en el formato solicitado por la empresa prestadora del servicio. En caso
//                     de que el Usuario no disponga del pasaje en el formato indicado a la hora de
//                     salida del viaje, quedará a criterio de la empresa el permitir o no al Usuario
//                     el realizar el viaje. <span className="bold-text">kupos.cl</span> no tendrá
//                     ninguna responsabilidad en caso de que la empresa no permita al Usuario viajar.{' '}
//                     <span className="bold-text">kupos.cl</span> tampoco será responsable por la
//                     pérdida, hurto, extravío o mal uso del pasaje de confirmación.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">11.11</div>
//                   <span>
//                     El tipo de vehículo solicitado puede estar sujeto a cambios según disponibilidad
//                     de la flota al momento de realizar el servicio, manteniéndose siempre la
//                     condición del servicio contratado, sea éste exclusivo, semi-compartido o
//                     colectivo, según el detalle de la reserva.
//                   </span>
//                 </div>

//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">11.12</div>
//                   <span>
//                     Cada pasajero tendrá derecho a cierta cantidad de equipaje, dependiendo de las
//                     condiciones del servicio contratado. Este varía dependiendo de la empresa
//                     prestadora del servicio.
//                   </span>
//                 </div>

//                 {/* body closing tag */}
//               </div>

//               {/* section tag closing */}
//             </div>

//             <div className="pp-section12">
//               <div className="title">
//                 <div className="number-and-text my-3 title">
//                   <div className="primary-circle">12</div>
//                   <span className="bold-text">Sobre cancelaciones de boletos:</span>
//                 </div>
//               </div>

//               <div className="body-items">
//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">12.1</div>
//                   <span>
//                     La cancelación o anulación de servicios adquiridos a través del Sitio Web debe
//                     ser procesada en línea, únicamente en las plataformas de{' '}
//                     <span className="bold-text">kupos.cl</span>.
//                   </span>
//                 </div>
//                 <div className="number-and-text my-3">
//                   <div className="secondary-circle">12.2</div>
//                   <span>
//                     El número de reserva y la confirmación de compra es el único documento válido
//                     para solicitar anulaciones de pasajes en{' '}
//                     <span className="bold-text">kupos.cl</span>.
//                   </span>
//                 </div>
//                 <div className="multi-tier">
//                   <div className="number-and-text my-3">
//                     <div className="secondary-circle">12.3</div>
//                     <span>
//                       Las condiciones de cancelación o devolución de boletos dependen de la empresa
//                       prestadora del servicio adquirido.
//                     </span>
//                   </div>

//                   <div className="number-and-text my-3 title">
//                     <div className="primary-circle">12.3.1</div>
//                     <div>
//                       <span>
//                         En el caso de Transfer Delfos, las cancelaciones o devoluciones de boletos
//                         podrán ser procesadas en cualquier momento antes de la hora de salida del
//                         viaje, teniendo las siguientes políticas de cancelación: <br></br>
//                         <br></br>
//                       </span>
//                     </div>
//                   </div>

//                   <div className="number-and-text my-3 title" style={{ marginLeft: 80 }}>
//                     <div className="secondary-circle" style={{ width: 40, height: 40 }}>
//                       12.3.1.1
//                     </div>
//                     <span>
//                       <span className="bold-text">
//                         Veinticuatro (24) horas antes de la hora del viaje:
//                       </span>
//                       Sin cargo de cancelación. Se devuelve el 100% del valor del pasaje.
//                     </span>
//                   </div>
//                   <div className="number-and-text my-3 title" style={{ marginLeft: 80 }}>
//                     <div className="secondary-circle" style={{ width: 40, height: 40 }}>
//                       12.3.1.2
//                     </div>
//                     <span>
//                       <span className="bold-text">
//                         Mínimo dos (2) horas antes de la hora del viaje:{' '}
//                       </span>{' '}
//                       Se retiene el 15%. Se devuelve el 85% del valor del pasaje.
//                     </span>
//                   </div>
//                   <div className="number-and-text my-3 title" style={{ marginLeft: 80 }}>
//                     <div className="secondary-circle" style={{ width: 40, height: 40 }}>
//                       12.3.1.3
//                     </div>
//                     <span>
//                       <span className="bold-text">
//                         {' '}
//                         Dentro de las últimas dos (2) horas antes de la hora del viaje
//                       </span>
//                       Se retiene el 100% del valor del pasaje. No corresponde devolución de dinero.
//                     </span>
//                   </div>
//                   {/* <span className="bold-text">
//                         Veinticuatro (24) horas antes de la hora del viaje:
//                       </span>{' '}
//                       Sin cargo de cancelación. Se devuelve el 100% del valor del pasaje.<br></br>
//                       <br></br>
//                       <span className="bold-text">
//                         Mínimo dos (2) horas antes de la hora del viaje:
//                       </span>{' '}
//                       Se retiene el 15%. Se devuelve el 85% del valor del pasaje.<br></br> <br></br>
//                       <span className="bold-text">
//                         Dentro de las últimas dos (2) horas antes de la hora del viaje:
//                       </span>{' '}
//                       Se retiene el 100% del valor del pasaje. No corresponde devolución de dinero. */}
//                 </div>

//                 <div className="multi-tier">
//                   <div className="number-and-text my-3">
//                     <div className="secondary-circle">12.4</div>
//                     <span>
//                       Al cancelar un pasaje, el Usuario tendrá las siguientes opciones de reembolso:
//                     </span>
//                   </div>

//                   <div className="number-and-text my-3 title">
//                     <div className="primary-circle">12.4.1</div>
//                     <span>
//                       Depósito en cuenta bancaria: Solo válido para cuentas bancarias chilenas.
//                       Procesado entre siete (7) y diez (10) días hábiles.
//                     </span>
//                   </div>
//                   <div className="number-and-text my-3 title">
//                     <div className="primary-circle">12.4.2</div>
//                     <span>
//                       Tarjeta de crédito: Solo válido para Usuarios que hayan procesado su compra
//                       utilizando Tarjeta de Crédito como medio de pago. Procesado entre siete (7) y
//                       diez (10) días hábiles.
//                     </span>
//                   </div>
//                   <div className="number-and-text my-3 title">
//                     <div className="primary-circle">12.4.3</div>
//                     <span>
//                       kupospay: Solo válido para Usuarios registrados y con cuenta verificada en
//                       <span className="bold-text">kupos.cl</span>. El reembolso se abona como saldo
//                       disponible en la cuenta kupospay del Usuario para futuras compras en el Sitio
//                       Web o cualquiera de las plataformas de{' '}
//                       <span className="bold-text">kupos.cl</span>.
//                     </span>
//                   </div>
//                   <div className="number-and-text my-3 title">
//                     <div className="primary-circle">12.4.4</div>
//                     <span>
//                       Las cancelaciones de pasajes tendrán un cargo adicional de CLP$600 por cada
//                       transacción anulada, por concepto de gastos administrativos y bancarios.
//                       Reembolsos solicitados a kupospay no tendrán cargos adicionales de
//                       cancelación.
//                     </span>
//                   </div>
//                   <div className="number-and-text my-3 title">
//                     <div className="primary-circle">12.4.5</div>
//                     <span>
//                       Una vez procesada la cancelación por parte del Usuario, no se permitirá cambio
//                       en el tipo de reembolso seleccionado.
//                     </span>
//                   </div>
//                   <div className="number-and-text my-3 title">
//                     <div className="primary-circle">12.4.6</div>
//                     <span>
//                       En caso de errores en los datos provistos por el Usuario al momento de
//                       procesar la anulación, <span className="bold-text">kupos.cl</span> solicitará
//                       al Usuario nuevamente la corrección de los datos proporcionados y el reembolso
//                       será procesado en un período de entre siete (7) y diez (10) días hábiles, a
//                       contar desde el día de recepción de los datos corregidos.
//                     </span>
//                   </div>
//                   <div className="number-and-text my-3 title">
//                     <div className="primary-circle">12.4.7</div>
//                     <span>
//                       En caso de que <span className="bold-text">kupos.cl</span> no reciba los datos
//                       solicitados al Usuario en un plazo de de tres meses desde la primera
//                       comunicación, el Usuario perderá su derecho a reembolso, entendiéndose que el
//                       servicio se ha prestado y que el dinero se ha pagado por concepto de precio
//                       del mismo.
//                     </span>
//                   </div>
//                   <div className="number-and-text my-3 title">
//                     <div className="primary-circle">12.4.8</div>
//                     <span>
//                       La confirmación de la cancelación será enviada a la cuenta de correo
//                       electrónico registrada durante la compra. Esta confirmación contendrá los
//                       datos de la cancelación como número de reserva anulado, monto de retención en
//                       caso de que corresponda, monto total a devolver y tipo de reembolso
//                       seleccionado.
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="mt-y-3 font13">
//               <div>
//                 <span className="terms-sub-head bold-text">
//                   SERVICIO DE VIAJES COMPARTIDOS Ó KUPOSPOOL
//                 </span>
//               </div>

//               <div className="pp-section1">
//                 <div className="title">
//                   <div className="number-and-text my-3 title">
//                     <div className="primary-circle">13</div>
//                     <span className="bold-text">
//                       Condiciones generales del servicio de viajes compartidos o{' '}
//                       <span className="bold-text">kupospool</span>:
//                     </span>
//                   </div>
//                 </div>

//                 <div className="body-items">
//                   <div className="number-and-text my-3">
//                     <div className="secondary-circle">13.1</div>
//                     <span>
//                       <span className="bold-text">kupos.cl</span> desarrolló un módulo de viajes o
//                       trayectos compartidos (en adelante{' '}
//                       <span className="bold-text">kupospool</span>) al que se puede acceder
//                       únicamente desde la app móvil de
//                       <span className="bold-text">kupos.cl</span>.{' '}
//                       <span className="bold-text">kupospool</span> está diseñada para poner en
//                       contacto a conductores que viajan a un determinado destino, con pasajeros que
//                       se dirigen al mismo lugar, de forma que puedan compartir el viaje y los costos
//                       asociados al mismo.
//                     </span>
//                   </div>

//                   <div className="number-and-text my-3">
//                     <div className="secondary-circle">13.2</div>
//                     <span>
//                       <span className="bold-text">kupospool</span> ofrece a los Usuarios registrados
//                       la posibilidad de publicar y ver anuncios de viaje (en adelante los
//                       “Anuncios”) e interactuar con ellos.
//                     </span>
//                   </div>

//                   <div className="number-and-text my-3">
//                     <div className="secondary-circle">13.3</div>
//                     <span>
//                       <span className="bold-text">kupos.cl</span> se reserva el derecho de, con
//                       fines de transparencia, establecer un sistema para verificar la totalidad o
//                       parte de la información proporcionada por el Usuario en su perfil con el fin
//                       de mejorar los procesos de verificación, prevención o detección de fraudes. El
//                       usuario entiende y acepta que, cualquier información “Certificada”,
//                       “Verificada” o cualquier término similar que se encuentre dentro de El Sitio,
//                       solamente significa que un Usuario ha superado con éxito el procedimiento de
//                       verificación existente en la plataforma con el fin de proporcionar más
//                       detalles sobre el Usuario. <span className="bold-text">kupos.cl</span>
//                       no puede garantizar la veracidad, fiabilidad o validez de la información
//                       sujeta al procedimiento de verificación.
//                     </span>
//                   </div>

//                   <div className="number-and-text my-3">
//                     <div className="secondary-circle">13.4</div>
//                     <span>
//                       Cualquier utilización de <span className="bold-text">kupospool</span>, tanto
//                       en calidad de Usuario como de Usuario Conductor, está relacionada con un
//                       nombre específico. La identidad del Usuario Conductor y del Usuario Pasajero
//                       debe corresponderse con la identidad comunicada por los mismos a{' '}
//                       <span className="bold-text">kupos.cl</span> y a los demás Usuarios que
//                       participan en el viaje o trayecto.
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="mt-y-3 font13">

//               <div className="pp-section1">
//                 <div className="title">
//                   <div className="number-and-text my-3 title">
//                     <div className="primary-circle">14</div>
//                     <span className="bold-text">
//                     Sobre publicación y anuncios de viajes:
//                     </span>
//                   </div>
//                 </div>

//                 <div className="body-items ">
//                   <div className="number-and-text my-3">
//                     <div className="secondary-circle">14.1</div>
//                     <span>
//                       El Usuario podrá crear anuncios dentro de{' '}
//                       <span className="bold-text">kupospool</span> proporcionando la información del
//                       trayecto o viaje a realizar, siempre y cuando cumpla con las condiciones
//                       indicadas a continuación:
//                     </span>
//                   </div>

//                   <div className="multi-tier">
//                     <div className="number-and-text my-3 title">
//                       <div className="primary-circle">14.1.1</div>
//                       <span>
//                         Depósito en cuenta bancaria: Solo válido para cuentas bancarias chilenas.
//                         Procesado entre siete (7) y diez (10) días hábiles.
//                       </span>
//                     </div>

//                     <div className="number-and-text my-3 title">
//                       <div className="primary-circle">14.1.2</div>
//                       <span>El usuario debe poseer un carnet o licencia de conducir válida.</span>
//                     </div>
//                     <div className="number-and-text my-3 title">
//                       <div className="primary-circle">14.1.3</div>
//                       <span>
//                         El usuario utiliza un vehículo propio o de terceros, con autorización
//                         expresa del propietario del vehículo; siempre y cuando esté autorizado para
//                         utilizar el vehículo con fines de desplazamiento compartido.
//                       </span>
//                     </div>
//                     <div className="number-and-text my-3 title">
//                       <div className="primary-circle">14.1.4</div>
//                       <span>
//                         El usuario es y seguirá siendo el conductor principal del vehículo de los
//                         anuncios.
//                       </span>
//                     </div>
//                     <div className="number-and-text my-3 title">
//                       <div className="primary-circle">14.1.5</div>
//                       <span>
//                         El usuario no tiene ninguna contraindicación o incapacidad médica para
//                         conducir.
//                       </span>
//                     </div>

//                     <div className="number-and-text my-3 title">
//                       <div className="primary-circle">14.1.6</div>
//                       <span>
//                         El usuario utiliza un vehículo en buen estado y que cumple con todas las
//                         normativas legales.
//                       </span>
//                     </div>

//                     <div className="number-and-text my-3 title">
//                       <div className="primary-circle">14.1.7</div>
//                       <span>
//                         Todas las plazas o asientos (en adelante los “kupos”) del vehículo ofertadas
//                         en el Anuncio del Usuario tienen cinturón de seguridad.
//                       </span>
//                     </div>
//                   </div>

//                   <div className="number-and-text my-3">
//                     <div className="secondary-circle">14.2</div>
//                     <span>
//                       El Usuario entiende y acepta que él es el único responsable del contenido del
//                       Anuncio publicado en <span className="bold-text">kupospool</span>; por lo que
//                       reconoce y garantiza la veracidad y precisión de toda la información incluida
//                       en el Anuncio; y se compromete a realizar el viaje o trayecto según las
//                       condiciones indicadas en el anuncio.
//                     </span>
//                   </div>

//                   <div className="number-and-text my-3">
//                     <div className="secondary-circle">14.3</div>
//                     <span>
//                       Los anuncios, siempre y cuando cumplan con estos términos, serán publicados en
//                       el Sitio y podrán ser vistos por todos los Usuarios que realicen búsquedas en
//                       <span className="bold-text">kupospool</span>.{' '}
//                       <span className="bold-text">kupos.cl</span> se reserva el derecho, a su
//                       exclusivo criterio y sin necesidad de previo aviso, de no publicar o borrar,
//                       en cualquier momento, cualquier anuncio que no cumpla con los presentes
//                       términos o que considere puede dañar su imagen, la imagen del Sitio o la
//                       imagen de los servicios.
//                     </span>
//                   </div>
//                   <div className="number-and-text my-3">
//                     <div className="secondary-circle">14.4</div>
//                     <span>
//                       El usuario reconoce y acepta que los criterios utilizados en la clasificación
//                       y el establecimiento del orden de visualización de los Anuncios es
//                       responsabilidad y criterio exclusivo de{' '}
//                       <span className="bold-text">kupos.cl</span>.
//                     </span>
//                   </div>
//                   <div className="number-and-text my-3">
//                     <div className="secondary-circle">14.5</div>
//                     <span>
//                       Es responsabilidad del Usuario Conductor el determinar el costo por kupo del
//                       viaje o trayecto compartido. El Usuario Conductor entiende y acepta que:
//                     </span>
//                   </div>

//                   <div className="multi-tier">
//                     <div className="number-and-text my-3 title">
//                       <div className="primary-circle">14.5.1</div>
//                       <span>
//                         Está prohibido obtener ningún tipo de beneficio mediante el uso de
//                         <span className="bold-text">kupospool</span>, por lo que acepta limitar los
//                         costos solicitados a los Usuarios Pasajeros a los costos reales del viaje o
//                         trayecto que se va a compartir.
//                       </span>
//                     </div>

//                     <div className="number-and-text my-3 title">
//                       <div className="primary-circle">14.5.2</div>
//                       <span>
//                         Al publicar un Anuncio de viaje, <span className="bold-text">kupos.cl</span>{' '}
//                         sugerirá un costo mínimo y máxima estándar por cada kupo, el cual debe
//                         usarse como guía para calcular el total en función de la naturaleza del
//                         viaje y de la distancia recorrida. Esta cantidad puede ser aumentada o
//                         reducida en función de los costos reales del viaje. Para evitar el uso
//                         abusivo del Sitio, <span className="bold-text">kupos.cl</span> limita la
//                         posibilidad de ajuste de los costos compartidos.
//                       </span>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="mt-y-3 font13">
//               {/* <div>
//                 <span className="terms-sub-head bold-text">
//                   Sobre reserva de viajes o anuncios de viajes:
//                 </span>
//               </div> */}

//               <div className="pp-section1">
//                 <div className="title">
//                   <div className="number-and-text my-3 title">
//                     <div className="primary-circle">15</div>
//                     <span className="bold-text">Sobre reserva de viajes o anuncios de viajes:</span>
//                   </div>
//                 </div>

//                 <div className="body-items">
//                   <div className="number-and-text my-3">
//                     <div className="secondary-circle">15.1</div>
//                     <span>
//                       <span className="bold-text">kupos.cl</span> desarrolló un módulo de viajes o
//                       trayectos compartidos (en adelante{' '}
//                       <span className="bold-text">kupospool</span>) al que se puede acceder
//                       únicamente desde la app móvil de
//                       <span className="bold-text">kupos.cl</span>.{' '}
//                       <span className="bold-text">kupospool</span> está diseñada para poner en
//                       contacto a conductores que viajan a un determinado destino, con pasajeros que
//                       se dirigen al mismo lugar, de forma que puedan compartir el viaje y los costos
//                       asociados al mismo.
//                     </span>
//                   </div>

//                   <div className="number-and-text my-3">
//                     <div className="secondary-circle">15.2</div>
//                     <span>
//                       El usuario, al estar interesado en un Anuncio, podrá realizar una solicitud de
//                       reserva y ésta será enviada inmediatamente al Usuario Conductor para su
//                       aceptación o rechazo. Una vez realizada la solicitud de reserva, el monto
//                       correspondiente al Anuncio solicitado será bloqueado de la cuenta del Usuario
//                       hasta que el Usuario Conductor acepte o rechace la solicitud.
//                     </span>
//                   </div>

//                   <div className="multi-tier">
//                     <div className="number-and-text my-3 title">
//                       <div className="primary-circle">15.2.1</div>
//                       <span>
//                         En caso de que el Usuario Conductor acepte la solicitud de reserva, el monto
//                         permanecerá bloqueado hasta la finalización del viaje.
//                       </span>
//                     </div>
//                     <div className="number-and-text my-3 title">
//                       <div className="primary-circle">15.2.2</div>
//                       <span>
//                         En caso de que el Usuario Conductor rechace la solicitud de reserva, el
//                         monto será reembolsado a la cuenta del Usuario.
//                       </span>
//                     </div>
//                     <div className="number-and-text my-3 title">
//                       <div className="primary-circle">15.2.3</div>
//                       <span>
//                         En caso de que la solicitud de reserva expire sin que el Usuario Conductor
//                         responda la solicitud, el monto será reembolsado a la cuenta del Usuario.
//                       </span>
//                     </div>
//                   </div>

//                   <div className="number-and-text my-3">
//                     <div className="secondary-circle">15.3</div>
//                     <span>
//                       kupospool está diseñado para reservar kupos para personas. Está prohibido
//                       reservar kupos para transportar objetos, paquetes, animales o cualquier otro,
//                       a menos que sea indicado al momento de hacer la solicitud de reserva.
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="mt-y-3 font13">
//               {/* <div>
//                 <span className="terms-sub-head bold-text">
//                   Sobre reserva de viajes o anuncios de viajes:
//                 </span>
//               </div> */}

//               <div className="pp-section1">
//                 <div className="title">
//                   <div className="number-and-text my-3 title">
//                     <div className="primary-circle">16</div>
//                     <span className="bold-text">Sobre sistema de evaluación:</span>
//                   </div>
//                 </div>

//                 <div className="body-items">
//                   <div className="number-and-text my-3">
//                     <div className="secondary-circle">16.1</div>
//                     <span>
//                       <span className="bold-text">kupos.cl</span> ofrece a los usuarios la
//                       posibilidad de calificar y dejar comentarios y/o valoraciones sobre un Usuario
//                       Conductor (en el caso de que sea un Usuario Pasajero) o sobre un Pasajero (en
//                       el caso de que sea un Usuario Conductor), siempre que hayan compartido un
//                       viaje o trayecto. Sin embargo, no está permitido dejar ningún comentario sobre
//                       otro Pasajero si eres un Usuario Pasajero, ni sobre ningún otro Usuario con
//                       quien no hayas viajado o con quien no tenías previsto viajar.
//                     </span>
//                   </div>

//                   <div className="number-and-text my-3">
//                     <div className="secondary-circle">16.2</div>
//                     <span>
//                       Las calificaciones, opiniones y comentarios serán utilizadas por{' '}
//                       <span className="bold-text">kupos.cl</span> para generar una calificación
//                       promedio tanto de los Usuarios Pasajeros como de los Usuarios Conductores.
//                     </span>
//                   </div>

//                   <div className="number-and-text my-3">
//                     <div className="secondary-circle">16.3</div>
//                     <span>
//                       El Usuario entiende y acepta que <span className="bold-text">kupos.cl</span>{' '}
//                       se reserva el derecho de no publicar o eliminar cualquier comentario, opinión
//                       o valoración en caso de que ésta incumpla lo establecido en los presentes
//                       términos.
//                     </span>
//                   </div>

//                   <div className="number-and-text my-3">
//                     <div className="secondary-circle">16.4</div>
//                     <span>
//                       <span className="bold-text">kupos.cl</span> se reserva el derecho a suspender
//                       cualquier cuenta, sea de Usuario Pasajero o Usuario Conductor; limitar el
//                       acceso a los servicios, o rescindir los presentes términos en caso de que (i)
//                       El Usuario haya recibido al menos tres valoraciones negativas y (ii) las
//                       opiniones promedias que hayas recibido tengan una puntuación de 3 o inferior.
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="mt-y-3 font13">
//               {/* <div>
//                 <span className="terms-sub-head bold-text">
//                   Sobre reserva de viajes o anuncios de viajes:
//                 </span>
//               </div> */}

//               <div className="pp-section1">
//                 <div className="title">
//                   <div className="number-and-text my-3 title">
//                     <div className="primary-circle">17</div>
//                     <span className="bold-text">
//                       Sobre métodos de pago y repago de los costos compartidos al Usuario Conductor:
//                     </span>
//                   </div>
//                 </div>

//                 <div className="body-items">
//                   <div className="number-and-text my-3">
//                     <div className="secondary-circle">17.1</div>
//                     <span>
//                       Al utilizar <span className="bold-text">kupospool</span>, el Usuario Conductor
//                       concede a <span className="bold-text">kupos.cl</span> una autorización de
//                       cobro de la cantidad de costos compartidos en su nombre y a su nombre. Por
//                       consiguiente, en el contexto de un viaje o trayecto, y tras la aceptación de
//                       la solicitud de reserva del Usuario Pasajero por parte del Usuario Conductor,{' '}
//                       <span className="bold-text">kupos.cl</span> cobra la cantidad total pagada por
//                       el Usuario Pasajero.
//                     </span>
//                   </div>

//                   <div className="number-and-text my-3">
//                     <div className="secondary-circle">17.2</div>
//                     <span>
//                       El Usuario Conductor reconoce y acepta que ninguna de las cantidades
//                       mencionadas recibidas por <span className="bold-text">kupos.cl</span> en
//                       nombre del Usuario Conductor dan derecho al cobro de intereses.
//                     </span>
//                   </div>

//                   <div className="number-and-text my-3">
//                     <div className="secondary-circle">17.3</div>
//                     <span>
//                       El Usuario Conductor se compromete a responder con debida diligencia a
//                       cualquier solicitud de <span className="bold-text">kupos.cl</span>, y en
//                       general, a cualquier autoridad administrativa o judicial competente,
//                       especialmente en lo relacionado con la prevención del blanqueo de capitales.
//                       Fundamentalmente el Usuario Conductor acepta proporcionar, tras su solicitud,
//                       cualquier elemento de prueba de su dirección y/o identidad que sea de
//                       utilidad. En caso de falta de respuesta a dichas solicitudes,{' '}
//                       <span className="bold-text">kupos.cl</span> podrá tomar las medidas que
//                       considere necesarias, como por ejemplo, congelar las cantidades pagadas y/o
//                       suspender la cuenta del Usuario Conductor.
//                     </span>
//                   </div>

//                   <div className="number-and-text my-3">
//                     <div className="secondary-circle">17.4</div>
//                     <span>
//                       Una vez finalizado el viaje o trayecto compartido, los Usuarios Pasajeros
//                       tendrán un período de veinticuatro (24) horas desde el momento en el que el
//                       viaje haya finalizado para presentar un reclamo a{' '}
//                       <span className="bold-text">kupos.cl</span> en caso de haber tenido algún
//                       inconveniente durante el viaje. En ausencia de reclamos de los Usuarios
//                       Pasajeros durante este período, <span className="bold-text">kupos.cl</span>{' '}
//                       considerará el viaje como confirmado y realizado.
//                     </span>
//                   </div>

//                   <div className="number-and-text my-3">
//                     <div className="secondary-circle">17.5</div>
//                     <span>
//                       A partir del momento de esta confirmación, el Usuario Conductor tendrá un
//                       crédito abonado en su cuenta kupospay. Este crédito se corresponde a la
//                       cantidad total pagada por los Usuarios Pasajeros en el momento de confirmar la
//                       Reserva. El Usuario Conductor puede utilizar este crédito abonado a su cuenta
//                       kupospay para cualquier otro servicio dentro de la plataforma{' '}
//                       <span className="bold-text">kupos.cl</span>.
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* </div> closing bracket main inner */}
//           </div>
//         </div>
//       </div>
//     );
//   }
// }

// {
// }



// WEBPACK FOOTER //
// ./src/features/pages/TermsAndConditions.js